export default __webpack_public_path__ + "static/media/pipe.f406c232.png";